import { useTranslation } from 'react-i18next';
import { usePopup } from '../../../providers/PopupProvider';
import { UserDetailsDto } from '../../../services/User/userService.dto';
import { userService } from '../../../services/User/userService';
import { useError } from '../../../providers/useError';
import UpdatePhoneNumberForm from '../components/UpdatePhoneNumberForm';
import { phoneUtils } from '../../../utils/phoneUtils';

export const useUpdatePhoneNumber = (onUpdated?: () => void) => {
  const { t } = useTranslation('users');
  const { showPopover, hidePopover, showConfirmPopover } = usePopup();
  const { errorMessage } = useError();

  const handleSave = (userId: number, value: string) => {
    const phoneDto = phoneUtils.convertToPhoneDto(value);
    if (!phoneDto) return;
    const onConfirm = () => {
      userService
        .updatePhoneNumber(userId, phoneDto)
        .then(() => {
          hidePopover();
          onUpdated?.();
        })
        .catch(error => errorMessage(error?.response?.data?.message));
    };
    showConfirmPopover(t('update-phone-number.save-confirmation', { userId }), onConfirm);
  };

  const showUpdatePhoneNumberPopover = (user: UserDetailsDto) => {
    showPopover(
      <UpdatePhoneNumberForm
        value={phoneUtils.convertToString(user.phone)}
        onConfirmPress={value => handleSave(user.id, value)}
      />
    );
  };

  return { showUpdatePhoneNumberPopover };
};
